import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { QuantAnalysis } from '@/components/icons/QuantAnalysis';
import type { WorkspaceGlobalSearchBarResultQuantAnalyses } from '@/types';
import { cx } from '@trinity/chat-components';
import ClickContainer from './Results.ClickContainer';
import styles from './style/Results.Transcript.module.css';

export default function ResultsQuantAnalyses({ className, index, item, highlighted }: Props) {
  return (
    <ClickContainer index={index} item={item}>
      <div className={cx(styles.root, { [styles.highlighted]: highlighted }, className)}>
        <QuantAnalysis className={styles.icon} />
        <div className={styles.details}>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.type}>Analysis</div>
        </div>
        {highlighted && (
          <div className={styles.return}>
            <KeyboardReturnIcon />
          </div>
        )}
      </div>
    </ClickContainer>
  );
}
export { ResultsQuantAnalyses };

type Props = {
  className?: string;
  index: number;
  item: WorkspaceGlobalSearchBarResultQuantAnalyses;
  highlighted?: boolean;
};